import NoSharings from "../../../processingActivity/processingActivityOverview/processingActivitySharingsTab/noSharings.svg?react";
import { DotLegalEmptyState } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { isNullOrWhitespace } from "@common/stringOperations.ts";
import { Box } from "@mui/material";

export interface DocumentsEmptyStateProps {
    errorText?: string;
}

function DocumentsEmptyState(props: DocumentsEmptyStateProps) {
    const { translateString } = useTranslation();

    const hasError = !isNullOrWhitespace(props.errorText);
    return (
        <Box
            sx={(theme) => ({
                "& .MuiBox-root": {
                    color: hasError ? theme.palette.error.main : undefined,
                    fontSize: hasError ? theme.typography.pxToRem(14) : undefined,
                },
            })}
        >
            <DotLegalEmptyState icon={<NoSharings />} text={hasError ? props.errorText : translateString("addRelevantDocuments")} />
        </Box>
    );
}

export default DocumentsEmptyState;
